// extracted by mini-css-extract-plugin
export default {"zoomModal":"w4-z","image":"x4-z","button":"y4-z","isOverlayShown":"z4-z"};